<template>
  <div class="sap-wrap">
    <h1>SAP - Configuration</h1>
  </div>
</template>

<script setup>
</script>

<style scoped>

</style>
